<template>
    <div>
        <toggle-button :value="booleanValue"
            :sync="true"
            :labels="{checked:$t(checkLabel),unchecked:$t(uncheckLabel)}"
            @change="change"
            :disabled="disabled"
            color="#009688">
        </toggle-button>
    </div>
</template>

<script>
    import ToggleButton from 'vue-js-toggle-button';
    import Vue from 'vue';
    Vue.use(ToggleButton);

    export default {
        props: {
            value: { type: [Boolean, Object], default: false },
            disabled: { type: [Boolean, Object], default: false },
            checkLabel: { type: String, default: 'toggle.checked' },
            uncheckLabel: { type: String, default: 'toggle.unchecked' },
            name: { type: String, default: '' }
        },
        computed: {
            booleanValue() {
                return this.normalizeValue(this.value);
            }
        },
        methods: {
            change(params) {
                this.$emit('input', params.value, this.name);
                this.populateStringValue(params.value);
            },
            normalizeValue(value) {
                if (typeof value === 'boolean') {
                    return value;
                }

                if (value === null || value === undefined) {
                    return false;
                }

                if (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
                    return Boolean(value.value);
                }

                return Boolean(value);
            },
            populateStringValue(value) {
                if (value) {
                    this.$emit('stringValueChanged', this.$t(`${this.checkLabel}`));
                } else {
                    this.$emit('stringValueChanged', this.$t(`${this.uncheckLabel}`));
                }
            }
        },
        mounted () {
            this.populateStringValue(this.normalizeValue(this.value));
        }
    }
</script>

<style scoped>
</style>
